import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagemVisualizadorComponent } from './imagem-visualizador/imagem-visualizador.component';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { ImageEditorModule } from '@syncfusion/ej2-angular-image-editor';

@NgModule({
  declarations: [
    ImagemVisualizadorComponent
  ],
  imports: [
    CommonModule,
    DialogAllModule,
    ImageEditorModule 
  ]
})
export class ImagemVisualizadorModule { }
